module.exports = __webpack_public_path__ + "static/in-patagonia-6944b82c39393d1ad484c66a9bbab5ff.jpg";